module.exports = __webpack_public_path__ + "static/raiden-selected-ccaa1f8a1baa36d19099a66955ad5a14.png";